export default {
  overview: {
    copiedListing: {
      content: "This listing has been successfully copied to your drafts.",
      button: "Edit copy",
    },
    degradeListing: {
      content: "This listing is degraded.",
    },
    missedFields: {
      bedrooms: "bedroom",
      grossArea: "gross area",
      saleableArea: "saleable area",
      location: "location info",
      error: {
        summary: "Mandatory {field} information is missing. ",
        details:
          "We have worked with you to migrate your listings across, but we didn't get the {field} details. This information is important to users viewing your listing and has been made mandatory. Please add this before you edit any other details.",
      },
      button: {
        close: "Close",
        add: "Add now",
      },
      content:
        "The mandatory {field} information is missing. Please add it before you edit other listing details.",
    },
    common: {
      imageTip: {
        error: "Invalid Image",
      },
      currency: {
        hkd: "HKD",
        hk: "HK$",
        rm: "RM",
      },
      buttons: {
        edit: "Edit",
        showMore: "View other languages",
        hideMore: "Hide other languages",
        upgrade: "Upgrade",
        back: "Back to my listings",
        backTop: "Back to the top",
        copy: "Copy",
        share: "Share",
        offline: "Take offline",
        delete: "Delete listing",
        cancel: "Cancel",
        extend: "Extend expiry",
      },
      unit: {
        million: "M",
        foot: "sq.ft.",
      },
    },
    tabs: {
      overview: "Overview",
      leads: "Leads({leadCount})",
      reporting: "Reporting",
    },
    action: {
      reactive: {
        offlineTip: "This listing is offline",
        expire: {
          tip: "This listing is expired",
          content:
            "Please note, if you choose to reactivate this property it will be treated as a new listing.",
          cancel: "Cancel",
          confirm: "Reactivate now",
        },
        button: "Reactivate",
      },
      cancelAutoUopgrade: {
        success: "Auto-upgrade for this listing has been cancelled.",
      },
    },
    media: {
      title: "Media",
      summary:
        '{photoCount} Photo{photoCount, plural, =0 {} =1{} other {s}}, {floorPlansCount} Floor plan{floorPlansCount, plural, =0 {} =1{} other {s}}, {photo360sCount} 360 image{photo360sCount, plural, =0 {} =1{} other {s}}{videoCount, plural, =1 {, <a href={videoLink} target="_blank">Video</a> } other { }}',
      image360s: '· <a href={image360sLink} target="_blank">360 Video</a>',
      tier: "Feature",
      alt: {
        coverImage: "Cover Image",
        image: "Image",
        floorplan: "Floor plans",
        photo360s: "360 images",
      },
      v3: {
        summary:
          '{photoCount} Photo{photoCount, plural, =0 {} =1{} other {s}}, {floorPlansCount} Floor plan{floorPlansCount, plural, =0 {} =1{} other {s}}{videoCount, plural, =1 {, <a href={videoLink} target="_blank">Video</a> } other { }}',
      },
    },
    tier: {
      title: "Listing Tier",
      legend: "Feature Listing",
      upgradedDate: "Upgraded on",
      expiresDate: "Upgrade expires in",
      rotation: "Next rotation",
      today: "Today",
      unit: "days, ",
      days: "days, ",
    },
    summary: {
      title: "Summary",
      listingType: "Listing type:",
      listingDetails: "Listing details",
      propertyType: "Property type:",
      propertySubType: "Property subtype:",
      id: "Listing ID:",
      status: "Listing status:",
      actionDate: {
        "2": "Listed on",
        "3": "Offline on",
        "5": "Expire on",
      },
      expires: "Listing expires in",
      updateDate: "Last updated on",
      firstPublished: "First published on",
      primaryAgent: "Primary agent:",
      secondaryAgent: "Secondary agent:",
      referenceNum: "Internal reference number:",
      propertyNo: "EAA required property number:",
      ownership: "Contract Ownership:",
      created: "Created By:",
      v3: {
        unitType: "Property unit type:",
      },
    },
    location: {
      title: "Location",
      address: {
        title: "Address",
      },
      alert: {
        message:
          "The accuracy of our location data has improved. We encourage you to update your listing(s) location to boost prominence. Existing listing(s) won't be affected, but updates are highly recommended when extending listing expiry.",
      },
    },
    propertyDetail: {
      title: "Property details",
      price: {
        title: "Price",
        buy: "Sale price:",
        rent: "Rent price:",
      },
      sizeDetails: {
        title: "Size details",
        saleable: "Saleable area (sq.ft.):",
        gross: "Gross area (sq.ft.):",
        area: "Area:",
        outdoor: "Outdoor area:",
      },
      format: {
        title: "Property Format",
        layout: "Property layout:",
        floorLevel: "Floor level:",
      },
      configuration: {
        title: "Property Configuration",
        bed: "Bedrooms:",
        bath: "Bathrooms:",
        carpark: "Carparks:",
      },
      other: {
        title: "Other details",
        orientation: "Orientation:",
        views: "Views:",
        condition: "Condition:",
      },
    },
    facilities: {
      title: "Property facilities",
      property: "Estate / Building facilities:",
      feature: "Property facilities:",
    },
    description: {
      title: "Description & Media",
      legends: {
        en_GB: "English",
        zh_CN: "Simplified chinese",
        zh_HK: "Traditional chinese",
        title: "Title:",
        description: "Description:",
      },
      disclaimer: {
        description:
          "Please note listings are subject to review post submission in accordance with our ",
        link: "Acceptable Use Policy.",
      },
    },
    manage: {
      title: "Manage listing",
      deleteButton: "Delete",
      onlineModal: {
        button: "Take this property offline",
        title: "Are you sure you want to take this listing offline?",
        content:
          "Note: The time your listing spends offline will not be reimbursed. Days remaining for an upgrade or standard listing will continue to be consumed.",
        cancel: "Cancel",
        ok: "Yes, take offline",
      },
      reactiveOffline: {
        label: "This listing is offline",
        buttonText: "Reactivate",
        note: "Please note, if you choose to reactivate this property it will be treated as a new listing.",
      },
      downgradeModal: {
        button: "Downgrade",
        title: "Are you sure you want to downgrade this listing to standard?",
        content:
          "The standard listing will on site for remaining days. The package balance (listings and upgrades) will not change.",
        cancel: "Cancel",
        ok: "Yes, proceed",
      },
      degradeModal: {
        title: "Are you sure you want to degrade this standard listing?",
        content:
          "This listing will be put below the normal standard listing tier.",
        cancel: "Cancel",
        ok: "Yes, proceed",
      },
      revertDegradeModal: {
        title:
          "Are you sure you want to revive this degraded standard listing?",
        content:
          "This listing will be revived to be a normal standard listing.",
        cancel: "Cancel",
        ok: "Yes, proceed",
      },
      cancelAutoUpgradeModal: {
        title: "Are you sure you want to cancel auto-upgrade?",
        content:
          "By cancelling auto-upgrade, your listing upgrade will expire in <strong>{dayDateTime}.</strong>",
        cancel: "Nope, keep it",
        ok: "Cancel auto-upgrade",
      },
      duplicateSpecificFailed: {
        title: "There was a problem copy this listing",
        DESCRIPTION_EXCEED_MAX_LENGTH:
          "The length of the description has exceeded the maximum of 600 character limit. {count, plural, =0 {} other {Try reducing the length of the description and then copy again.}}",
        DESCRIPTION_CONTAINS_RACIST_WORD:
          "Description contains race related or other unacceptable words. {count, plural, =0 {} other {Please edit your description and then copy again.}}",
        LISTING_REQUIRED_UPDATE_LOCATION:
          "The location information needs to be updated first, and then try copying again.",
        INVALID_PSF_PRICE:
          "The minimum price per sqft for this listing must be at least RM {minPsf}. {count, plural, =0 {} other {Try increasing price per sqft, and then copy again.}}",
        INVALID_SALE_PRICE:
          "The minimum sale price for this listing must be at least RM10,000. {count, plural, =0 {} other {Try increasing sale price, and then copy again.}}",
        INVALID_RENT_PRICE:
          "The minimum rent price for this listing must be at least RM200. {count, plural, =0 {} other {Try increasing rent price, and then copy again.}}",
        INVALID_GROSS_AREA:
          "The minimum land area for this listing must be at least 100 sqft. {count, plural, =0 {} other {Try increasing land area, and then copy again.}}",
        cancel: "Cancel",
        editNow: "Edit now",
        ok: "OK",
        error: "Something went wrong. Please try again later.",
      },
    },
    share: {
      title: "Share",
      type: {
        facebook: "Facebook",
        whatsapp: "Whatsapp",
        wechat: "WeChat",
        weibo: "Weibo",
        linkedin: "Linkedin",
        twitter: "Twitter",
        "google-plus": "Google+",
        link: "Copy link",
        email: "Email",
      },
      wechatModal: {
        title: "Share with WeChat",
        message: "Scan the QR code to log into WeChat to share this property",
      },
    },
  },
};
